import { render } from "./BovineList.vue?vue&type=template&id=78cd242f&scoped=true"
import script from "./BovineList.vue?vue&type=script&lang=js"
export * from "./BovineList.vue?vue&type=script&lang=js"

import "./BovineList.vue?vue&type=style&index=0&id=78cd242f&lang=css&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cd242f"]])

export default __exports__